var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { DesignerMainModule } from './main/main.module';
import { RouterModule } from '@angular/router';
import { API_BASE_URL } from './shared/service-proxies/service-proxies';
import { DesignerComponent } from './designer.component';
import { DesignerRoutingModule } from './designer-routing.module';
import { AppConsts } from './shared/AppConsts';
export function getRemoteServiceBaseUrl() {
    // 获取后端服务器地址 可在fcloud中写入缓存
    // 获取后端服务器地址 可在fcloud中写入缓存
    AppConsts.appBaseUrlFormat = localStorage.getItem('appBaseUrl');
    AppConsts.remoteServiceBaseUrl = localStorage.getItem('remoteServiceBaseUrl');
    return AppConsts.remoteServiceBaseUrl || localStorage.getItem('remoteServiceBaseUrl');
}
var DesignerModule = /** @class */ (function () {
    function DesignerModule() {
    }
    DesignerModule = __decorate([
        NgModule({
            imports: [
                CommonModule,
                FormsModule,
                DesignerMainModule,
                RouterModule,
                DesignerRoutingModule
            ],
            declarations: [
                DesignerComponent
            ],
            exports: [],
            providers: [
                { provide: API_BASE_URL, useFactory: getRemoteServiceBaseUrl },
            ],
            entryComponents: []
        })
    ], DesignerModule);
    return DesignerModule;
}());
export { DesignerModule };
